import type { HostEvent } from './views';

/**
 * Presentation time per event. Shared by the client animation director (pacing) and the host
 * (turn deadlines include the time it takes to animate chained bot moves).
 */
export const EVENT_DURATION_MS: Readonly<Record<HostEvent['t'], number>> = {
  MATCH_STARTED: 300,
  HAND_STARTED: 500,
  CARDS_DEALT: 700,
  HAND_RECEIVED: 0,
  RESERVE_REQUIRED: 200,
  TRUMP_RESERVED: 500,
  RESERVED_CARD: 0,
  TURN_STARTED: 0,
  CARD_PLAYED: 650,
  TRUMP_SET: 900,
  TRUMP_REVEALED: 1400,
  TRICK_WON: 1200,
  HAND_SCORED: 800,
  MATCH_COMPLETE: 400,
  AUTO_PLAYED: 300,
  BOT_TAKEOVER: 300,
  PLAYER_RETURNED: 200,
  ROOM_ABANDONED: 0,
};

export function animationBudgetMs(events: readonly HostEvent[]): number {
  return events.reduce((sum, e) => sum + EVENT_DURATION_MS[e.t], 0);
}

export const TIMING = {
  /** Result screen shown before the next hand may be dealt without everyone agreeing. */
  RESULT_PAUSE_MS: 8000,
  /** Grace before a disconnected player's seat is handed to a bot (PRD §8). */
  DISCONNECT_GRACE_MS: 60_000,
  /** Fresh turn time given to a player who returns on their own turn. */
  RECONNECT_TURN_MS: 15_000,
  /** Clock tolerance when a client claims a timeout. */
  CLAIM_TOLERANCE_MS: 750,
  /** Consecutive timeouts before a seat is handed to a bot. */
  MAX_TIMEOUTS_BEFORE_BOT: 2,
  /** Lobby rooms idle this long are abandoned by the sweeper. */
  IDLE_ROOM_MS: 30 * 60_000,
} as const;
